import { buildUrl } from '@axa-fr-axion/restful';
import { BFF_HOST, BFF_PATHNAME, BFF_GET_OFFERS_PATH, BFF_RECOMMANDATION_PATH } from 'services/shared';

export const buildRecommandationUrl = (
    codeSector: string,
    legalStatus = '',
    income = '',
    numberOfEmployees = ''
): string => buildUrl(
    [
        BFF_HOST,
        BFF_PATHNAME,
        BFF_RECOMMANDATION_PATH,
        BFF_GET_OFFERS_PATH,
        codeSector,
    ],
    {
        statutJuridique: legalStatus,
        chiffreAffaires: income,
        effectif: numberOfEmployees,
    },
);
